export const PHASE_MAP = {
  assigned: "tof",
  "to-contact": "tof",
  searching: "mof",
  tracking: "mof",
  "scheduled-tour": "mof",
  "finished-tour": "mof",
  offer: "bof",
  downpayment: "bof",
  contract: "bof",
  "closing-trade": "bof"
};

export const PHASE_CLASS = {
  assigned: "purple lighten-5 deep-purple--text text--darken-4",
  "to-contact": "purple lighten-5 deep-purple--text text--darken-4",
  searching: "purple lighten-5 deep-purple--text text--darken-4",
  tracking: "purple lighten-5 deep-purple--text text--darken-4",
  "scheduled-tour": "purple lighten-5 deep-purple--text text--darken-4",
  "finished-tour": "purple lighten-5 deep-purple--text text--darken-4",
  offer: "purple lighten-5 deep-purple--text text--darken-4",
  downpayment: "blue lighten-5 blue--text text--darken-4",
  contract: "blue lighten-5 blue--text text--darken-4",
  "closing-trade": "blue lighten-5 blue--text text--darken-4",
  finished: "yellow lighten-5 brown--text text--darken-4",
  discarded: "grey lighten-2 grey--text text--darken-4"
};

export const SUBHEADING = [
  { key: "tof", name: "TOF", colspan: 0, total: 0, percent: 0 },
  { key: "mof", name: "MOF", colspan: 0, total: 0, percent: 0 },
  { key: "bof", name: "BOF", colspan: 0, total: 0, percent: 0 }
];

export const CURRENCY_FORMATER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0
});

export const buildHeaders = customHeaders => {
  const basicConfig = {
    class: "primary white--text",
    justify: "center",
    align: "center",
    sortable: false
  };

  const basicHeaders = [
    { text: "Broker", value: "name", sortable: true },
    { text: "Leads", value: "totalByContact", sortable: true },
    { text: "Brokers externos", value: "brexByContact" },
    { text: "", value: "inmediatly", width: "50px", cellClass: "pa-0" },
    {
      text: "",
      value: "probability",
      width: "50px",
      class: " white--text",
      cellClass: "pa-0"
    },
    ...customHeaders,
    {
      text: "Venta",
      value: "finished",
      class: "yellow lighten-5 brown--text text--darken-4",
      cellClass: "pa-0"
    },
    {
      text: "Descartado",
      value: "discarded",
      class: "grey lighten-2 grey--text text--darken-4",
      cellClass: "pa-0"
    }
  ];
  return basicHeaders.map(header => ({ ...basicConfig, ...header }));
};
